import React from "react"
import { Button, Text } from "@chakra-ui/react"
import { Link } from "react-scroll"
import "./styles.scss"

export default function MenuItem ({ children, isLast, page = "/", ...rest }) {
    return (
    <Button d="block" lineHeight={1} color="teal" _hover={{ bg: "#d9e4ec" }} variant="ghost" size="lg" fontSize="18px" fontWeight="700">
        <Link to={page} smooth={true}>
        { children }
        </Link>
    </Button>
    )
  }
  